import ClientAgent from '../../clientAgent'
import {Obvestilo} from '../SplosneGlobalneFunkcije/Notification.js'

let avatarUrl = null

export default {
  methods: {
    PridobiAvatar (forceReload = false) {
      if (avatarUrl !== null && !forceReload) {
        return avatarUrl
      }
      let cAgent = new ClientAgent()
      cAgent.postWsRequest(
        this,
        'user/info',
        [],
        [],
        'SetPridobiAvatar',
        'ErrPridobiAvatar')
    },
    ValidirajDatoteko (file) {
      if (file === null) {
        return false
      }
      if (typeof file.file === 'undefined') {
        return false
      }
      const isJPG = file.file.type === 'image/jpg' || file.file.type === 'image/jpeg' ||
        file.file.type === 'image/png'
      const isLt1M = file.file.size / 1024 / 1024 < 1
      if (!isJPG) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Slika profila je lahko v formatih JPG, JPEG ali PNG.'
        this.ShowWarningMessage(paramObvestilo)
        return false
      }
      if (!isLt1M) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Velikost profilne slike ne sme presegati velikosti 1 MB.'
        this.ShowWarningMessage(paramObvestilo)
        return false
      }
      return true
    },
    SetPridobiAvatar (podatki) {
      let date = new Date()
      avatarUrl = podatki.picture + '?time=' + date.getTime()
      this.$root.$emit('posodobitevSlikeHandler')
    },
    ErrPridobiAvatar (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      Obvestilo.methods.ShowWarningMessage(paramObvestilo)
    },
    ShraniAvatar (file) {
      let isValidFile = this.ValidirajDatoteko(file)
      if (!isValidFile) {
        return false
      }
      let param = ['data=' + btoa(this.avatarFile.data)]
      param.push('mimeType=' + this.avatarFile.file.type)
      this.clientAgent.postWsRequest(
        this,
        'user/saveAvatar?',
        param,
        null,
        'PosodobiAvatar',
        '')
    },
    PosodobiAvatar () {
      this.PridobiAvatar(true)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/PridobitevUporabniskihPodatkovGlobalno/Avatar.js